import React from 'react'
import {Box,Container, Grid, Typography} from "@mui/material";
import useWindowDimensions from "../../utils/Helpers";

const tree_species = require("../../data/tree_species.json")
const PictureLayout= (props:any) =>{
    const {language} = props
    const input = JSON.parse(localStorage.getItem("tum_leitfaden_input") as string) as any
    const tree_specie = tree_species[language].find((tree_specie: any) => tree_specie.id === input.tree_species)
    const {width} = useWindowDimensions();
    return(
        <Container>
            <Box sx={{maxWidth: width * 0.8, maxHeight:500}}>
                <Grid item xs={12} style={{textAlign: "center", padding: 4, margin: 8}}>
                    <Typography variant="h5">
                        {tree_specie.name}
                    </Typography>
                    <Box sx={{
                        position:"relative",
                        display:"inline-block",
                        marginBottom: 8
                    }}>
                        <Box
                            sx={{maxWidth: '100%' }}
                            component="img"
                            alt="Tree"
                            src={require("../../assets/trees/" + tree_specie["tree_picture"])}
                        />
                        <Box
                            component="img"
                            sx={{
                                position: 'absolute', bottom: -75, right: -50,
                                maxWidth: 250,
                                maxHeight: 250,
                                transform: `rotate(150deg)`,
                            }}
                            alt="Blatt"
                            src={require("../../assets/species/" + tree_specie.picture)}
                        />
                    </Box>
                </Grid>
            </Box>
        </Container>
    )
}
export default PictureLayout
